import React, { useState, useEffect } from 'react';
import { object, string, bool } from 'prop-types';
import Cookies from 'js-cookie';

import Slide from '@material-ui/core/Slide';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import Button from '../../../../Button';
import Image from '../../../../Image';
import Typography from '../../../../Typography';
import ROUTES, { getPath } from '../../../../../routes';
import { makeURLWithParams } from '../../../../../utils/globals';

import useConnect from './hooks';
import messages from './messages';
import useStyles from './styles';

export const COOKIE_NAME = 'CookieAgreement';

export const COOKIE_VALUE = 'drsa';

const getCookie = name => Boolean(Cookies.get(name));

const NewCookieBanner = ({ settings: { COOKIES_PDF, COOKIE_DURATION }, isEmbedded, token }) => {
  const classes = useStyles();
  const { setOptionalCookies } = useConnect();
  const [isMandatoryCookiesAccepted, setIsMandatoryCookiesAccepted] = useState(getCookie(`${token}_${COOKIE_NAME}`));
  const [isBannerDisplayed, setIsBannerDisplayed] = useState(!isMandatoryCookiesAccepted);
  const [isAnalyticsEnabled, setIsAnalyticsDisabled] = useState(Boolean(localStorage.getItem(`${token}-analytics`)));

  const crossSiteCookie = isEmbedded && { SameSite: 'None', Secure: true };

  const handleBanner = () => {
    setIsBannerDisplayed(!isBannerDisplayed);
  };

  const handleMandatoryCookies = () => {
    Cookies.set(`${token}_${COOKIE_NAME}`, COOKIE_VALUE, { expires: COOKIE_DURATION, ...crossSiteCookie });
    setIsMandatoryCookiesAccepted(getCookie(`${token}_${COOKIE_NAME}`));
  };

  const handleAnalytics = () => {
    setIsAnalyticsDisabled(!isAnalyticsEnabled);
  };

  const onContinue = () => {
    handleMandatoryCookies();
    if (isAnalyticsEnabled) {
      localStorage.setItem(`${token}-analytics`, true);
    }

    if (!isAnalyticsEnabled) {
      localStorage.removeItem(`${token}-analytics`);
    }
    handleBanner();
  };

  useEffect(() => {
    setOptionalCookies({ analytics: true });
  }, []); // eslint-disable-line

  return (
    <>
      <ButtonBase onClick={handleBanner} className={classes.cookieButton}>
        <Image name="cookiebutton" />
      </ButtonBase>

      <Slide direction="up" in={isBannerDisplayed} mountOnEnter unmountOnExit>
        <Paper square elevation={0} className={classes.paper}>
          <Box className={`${classes.bannerContent} cookie-banner-content`}>
            <Box className="cookie-consent">
              <Typography
                name="title"
                variant="subtitle1"
                align="left"
                content={messages.cookieBannerTitle}
                gutterBottom
              />
              <Typography
                name="sub-title"
                component="b"
                variant="inherit"
                align="left"
                content={messages.mandatoryCookiesTitle}
                gutterBottom
              />
              <Typography
                name="paragraph"
                variant="subtitle2"
                align="left"
                content={messages.mandatoryCookiesParagraph}
                gutterBottom
              />
              <Typography
                name="sub-title"
                component="b"
                variant="inherit"
                align="left"
                content={messages.optionalCookiesTitle}
                gutterBottom
              />
            </Box>
            <Box className={`${classes.optionalCookies} optional-cookies`}>
              <FormControlLabel
                onChange={handleAnalytics}
                control={<Switch color="primary" checked={isAnalyticsEnabled} />}
                label={<Typography variant="subtitle2" content={messages.analyticsCookies} />}
                labelPlacement="start"
              />
            </Box>
            <Box className={`${classes.buttonsContainer} action-button-container`}>
              <Button
                variant="outlined"
                content={messages.more}
                href={makeURLWithParams(getPath(ROUTES.LEGISLATION), {
                  pdf: COOKIES_PDF ? 'cookies_legacy' : 'term_condition',
                })}
                target="_blank"
                className={`${classes.button} ${classes.moreButton} more-button`}
              />
              <Button
                content={messages.continue}
                onClick={onContinue}
                className={`${classes.button} continue-button`}
              />
            </Box>
          </Box>
        </Paper>
      </Slide>
    </>
  );
};

NewCookieBanner.propTypes = {
  settings: object,
  token: string,
  isEmbedded: bool,
};

export default NewCookieBanner;
